import cn from 'classnames';
import { ErrorMolecule } from '../../molecules';
import { useEffect, useRef, useState } from 'react';
import { LandscapesTemplate } from '../../templates';
import { useInfiniteGetLandscapes } from '../../../store/landscapeAPI/landscape/queries/landscape.queries';
import Spinner from '../../atoms/Spinner/Spinner';
import { useNavigate } from 'react-router-dom';
import { SortConfig } from '../../../utils/types/types';
import { SortBy } from '../../../store/landscapeAPI/landscape/dto/request/all-landscapes.dto';
import styles from './LandscapesPage.module.css';

const LandscapesPage = () => {
  const navigate = useNavigate();
  const [sortConfig, setSortConfig] = useState<SortConfig>({
    key: 'name',
    direction: 'asc',
  });

  const {
    data,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    status,
    error,
  } = useInfiniteGetLandscapes({
    pageSize: 10,
    sortBy: sortConfig.key as SortBy,
    sortDirection: sortConfig.direction,
  });

  const loadMoreRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!hasNextPage || !loadMoreRef.current) return;
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          fetchNextPage();
        }
      },
      { rootMargin: '100px' }
    );

    observer.observe(loadMoreRef.current);

    return () => observer.disconnect();
  }, [hasNextPage, fetchNextPage]);

  const handleLandscapeClick = (id: string) => {
    navigate(`/landscapes/edit/${id}/basic-information`);
  };

  if (status === 'pending') {
    return <Spinner />;
  }

  if (status === 'error') {
    return <ErrorMolecule content={error.message ?? ''} />;
  }

  const landscapes = data?.pages.flatMap((page) => page.data) ?? [];

  return (
    <>
      {landscapes && (
        <div className={cn(styles.landscapesWrapper)}>
          <LandscapesTemplate
            data={landscapes}
            handleLandscapeClick={handleLandscapeClick}
            sortConfig={sortConfig}
            setSortConfig={setSortConfig}
          />
          <div ref={loadMoreRef} style={{ height: 1 }} />
          {isFetchingNextPage && (
            <p className={styles.landscapesLoaderText}>Loading more...</p>
          )}
        </div>
      )}
    </>
  );
};

export default LandscapesPage;
